export default __webpack_public_path__ + "static/media/Aura-Egg__74.b4a0cd30.png";